import { ReactNode } from 'react';

import { Text } from '@iwoca/orion-ui';

export const SummaryRow = ({
    label,
    value
}: {
    label: ReactNode;
    value: ReactNode;
}) => (
    <div className="flex items-center justify-between">
        <Text className="text-structure-100">{label}</Text>
        <Text className="font-bold text-structure-100">{value}</Text>
    </div>
);
